const SnakeIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    width={props.size || 32}
    height={props.size || 32}
    fill="currentColor"
    {...props}
  >
    <path d="M15.25 12a.75.75 0 0 0 .75-.75v-9.5C16 .785 15.215 0 14.25 0H1.75C.785 0 0 .785 0 1.75v12.5C0 15.215.785 16 1.75 16h12.5c.965 0 1.75-.785 1.75-1.75v-.5a.75.75 0 0 0-1.5 0v.5a.25.25 0 0 1-.25.25H1.75a.25.25 0 0 1-.25-.25V1.75a.25.25 0 0 1 .25-.25h12.5a.25.25 0 0 1 .25.25v9.5c0 .414.336.75.75.75z" />
    <path d="M6.75 7h4.5C12.215 7 13 6.215 13 5.25V4.5c0-.965-.785-1.75-1.75-1.75h-7.5a.75.75 0 0 0 0 1.5h7.5a.25.25 0 0 1 .25.25v.75a.25.25 0 0 1-.25.25h-4.5C5.785 5.5 5 6.285 5 7.25v1C5 9.215 5.785 10 6.75 10h3.5a.25.25 0 0 1 .25.25v2a.75.75 0 0 0 1.5 0v-2c0-.965-.785-1.75-1.75-1.75h-3.5a.25.25 0 0 1-.25-.25v-1A.25.25 0 0 1 6.75 7z" />
  </svg>
);

export default SnakeIcon;
